// Page-local navigation. Native anchor links also work without this enhancement.
if (!customElements.get('cu-page-nav')) {
  customElements.define('cu-page-nav', class extends HTMLElement {
    connectedCallback() {
      this.page = this.closest('.cu-astra');
      this.header = document.querySelector('.cu-header');
      this.items = [...this.querySelectorAll('a[href^="#"]')].map(link => ({
        link, section: document.getElementById(link.hash.slice(1)),
      })).filter(item => item.section);
      if (!this.page || !this.items.length) return;

      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.updateCurrent();
        });
      };
      this.measure = () => {
        this.headerHeight = this.header ? this.header.offsetHeight : 0;
        this.page.style.setProperty('--cu-astra-header-height', this.headerHeight + 'px');
        // Mobile navigation stays in the page flow, so it needs no anchor offset.
        this.stickyHeight = getComputedStyle(this).position === 'sticky' ? this.offsetHeight : 0;
        this.page.style.setProperty('--cu-astra-index-height', this.stickyHeight + 'px');
        this.schedule();
      };
      this.resizeObserver = new ResizeObserver(this.measure);
      this.resizeObserver.observe(this);
      if (this.header) this.resizeObserver.observe(this.header);
      window.addEventListener('scroll', this.schedule, { passive: true });
      window.addEventListener('resize', this.measure);
      window.addEventListener('hashchange', this.schedule);
      this.measure();
    }

    updateCurrent() {
      // This reading line also matches the anchor offset when the main header
      // returns on upward scroll. Unlisted sections do not claim a selected tab.
      const readingLine = this.headerHeight + this.stickyHeight + 20;
      let active = null;
      this.items.forEach(item => {
        const rect = item.section.getBoundingClientRect();
        if (rect.top <= readingLine && rect.bottom > readingLine) active = item;
      });
      if (!active && this.items[0].section.getBoundingClientRect().top > readingLine) active = this.items[0];
      this.items.forEach(item => {
        if (item === active) item.link.setAttribute('aria-current', 'location');
        else item.link.removeAttribute('aria-current');
      });
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.resizeObserver?.disconnect();
      window.removeEventListener('scroll', this.schedule);
      window.removeEventListener('resize', this.measure);
      window.removeEventListener('hashchange', this.schedule);
    }
  });
}
